import React from 'react';
import { ModalContainer } from './components';
import Header from './components/ModalHeader';
import Menu from './components/ModalMenu';
import { Content, Footer } from './styles';

interface Props {
  title?: string;
  footer?: JSX.Element;
  onConfirm?: () => void;
  onCancel?: () => void;
  children?: React.ReactNode;
}

export const Modal = ({
  title,
  footer,
  onCancel,
  onConfirm,
  children,
}: Props) => {
  return (
    <ModalContainer width={360}>
      <Header title={title} onClick={onCancel} />
      <Content>{children}</Content>
      <Footer>
        {footer ||
          (onConfirm && <Menu onConfirm={onConfirm} onCancel={onCancel} />)}
      </Footer>
    </ModalContainer>
  );
};
